import styled, { css } from 'styled-components/macro';
import { BaseProps, ColorType } from './link.types';

const linkModes = {
  primary: 'accent',
  gray: 'neutral',
  green: 'success',
  orange: 'warning',
  red: 'error',
  purple: 'super',
} as const satisfies Record<ColorType, string>;

/* 
  Указан тег <a>, но в StyledWrapper компонент передается
  пропс as, который поменяет <a> на <button>,
  если asButton = true
 */
export const StyledWrapper = styled.a<BaseProps>`
  ${({ theme, color, underline, truncate }) => css`
    position: relative;
    padding: 0;
    margin: 0;
    display: inline-block;
    width: fit-content;
    border: none;
    outline: none;
    background-color: transparent;
    text-decoration: none;
    color: ${theme.semantic.link[linkModes[color ?? 'primary']].text};
    cursor: pointer;
    transition-duration: ${theme.tokens.animation.duration.base};
    text-align: left;
    text-underline-offset: 2px;

    &:hover {
      color: ${theme.semantic.link[linkModes[color ?? 'primary']].textHover};
      text-decoration: underline;
    }

    &:disabled {
      color: ${theme.semantic.link.textDisabled};
      opacity: 0.5;
      pointer-events: none;
    }

    ${underline &&
    css`
      text-decoration: underline;
    `}

    ${truncate &&
    css`
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  `}
`;
